module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroll-hor-cont"
  }, [_c('div', {
    staticClass: "activ-deci"
  }, [_c('div', {
    staticClass: "activ-deci-container"
  }, [_c('div', {
    staticClass: "linea-inicio linea-inicio-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "linea-inicio linea-inicio-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "caso",
    attrs: {
      "tabindex": "0",
      "id": "inicio-decisiones"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('ui-lsc-dialog', {
    attrs: {
      "vidTittle": 'La historia de Juliana',
      "videoEmbed": "ADMINISTRACIONDINERO7_02 (9).mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('bot-decisiones', {
    staticClass: "caso-1",
    attrs: {
      "aria-label": "Oferta de trabajo",
      "lineAfter": _vm.aceptaTrabajo === 'acepta-trabajo' || _vm.aceptaTrabajo === 'no-acepta-trabajo'
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDiag($event, 'botonUno')
      }
    }
  }), _vm._v(" "), _c('bot-decisiones', {
    staticClass: "caso-2",
    attrs: {
      "aria-label": "Viaje con amigas",
      "lineAfter": _vm.ofertaViaje === 'va-de-viaje' || _vm.ofertaViaje === 'no-va-de-viaje'
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDiag($event, 'botonDos')
      }
    }
  }), _vm._v(" "), (_vm.aceptaTrabajo === 'acepta-trabajo') ? [_c('div', {
    staticClass: "lines-acepta-trabajo"
  }), _vm._v(" "), _c('bot-decisiones', {
    staticClass: "acepta-trabajo-1",
    attrs: {
      "aria-label": "Oferta para ahorrar",
      "id": "acepta-trabajo-1",
      "lineAfter": false
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDiag($event, 'acepta-trabajo-1')
      }
    }
  }), _vm._v(" "), _c('bot-decisiones', {
    staticClass: "acepta-trabajo-2",
    attrs: {
      "aria-label": "Decide comprar moto",
      "lineAfter": false
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDiag($event, 'acepta-trabajo-2')
      }
    }
  }), _vm._v(" "), (_vm.ahorrarFondo === 'acepta-ahorrar-fondo') ? _c('bot-decisiones', {
    staticClass: "ahorrar-fondo",
    attrs: {
      "aria-label": "Acepta ahorrar en fondo",
      "id": "ahorrar-fondo",
      "lineAfter": false
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDiag($event, 'ahorrar-fondo')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.comprarMoto === 'compra-nueva') ? _c('bot-decisiones', {
    staticClass: "comprar-moto",
    attrs: {
      "aria-label": "Comprar moto nueva",
      "id": "comprar-moto-nueva",
      "lineAfter": false
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDiag($event, 'comprar-moto-nueva')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.comprarMoto === 'compra-usada') ? _c('bot-decisiones', {
    staticClass: "comprar-moto",
    attrs: {
      "aria-label": "Comprar moto usada",
      "id": "comprar-moto-usada",
      "lineAfter": false
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDiag($event, 'comprar-moto-usada')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.comprarMoto === 'no-compra') ? _c('bot-decisiones', {
    staticClass: "comprar-moto",
    attrs: {
      "aria-label": "No comprar moto",
      "id": "no-comprar-moto",
      "lineAfter": false
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDiag($event, 'no-comprar-moto')
      }
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.aceptaTrabajo === 'no-acepta-trabajo') ? [_c('div', {
    staticClass: "lines-no-acepta-trabajo"
  }), _vm._v(" "), _c('bot-decisiones', {
    staticClass: "no-acepta-trabajo-1",
    attrs: {
      "aria-label": "Se queda como independiente",
      "id": "no-acepta-trabajo-1",
      "lineAfter": false
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDiag($event, 'no-acepta-trabajo-1')
      }
    }
  })] : _vm._e(), _vm._v(" "), (_vm.ofertaViaje === 'va-de-viaje') ? _c('div', {
    staticClass: "lineas-se-va-de-viaje"
  }) : _vm._e(), _vm._v(" "), (_vm.ofertaViaje === 'va-de-viaje') ? _c('bot-decisiones', {
    staticClass: "viaje-tarjeta",
    attrs: {
      "aria-label": "Pago con tarjeta de crédito",
      "id": "viaje-tarjeta",
      "lineAfter": false
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDiag($event, 'viaje-tarjeta')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ofertaViaje === 'va-de-viaje') ? _c('bot-decisiones', {
    staticClass: "viaje-libre-invesion",
    attrs: {
      "aria-label": "Crédito libre inversión",
      "lineAfter": false
    },
    nativeOn: {
      "click": function($event) {
        _vm.showDiag($event, 'viaje-libre-invesion')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pregunta) ? [(_vm.preguntaDesc === 'botonUno') ? _c('seleccion-deci', {
    staticClass: "oferta-trabajo",
    style: (_vm.estilosDeci),
    attrs: {
      "selWidth": _vm.preguntaWidth
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-right": ""
    }
  }, [_c('ui-lsc-dialog', {
    attrs: {
      "vidTittle": 'Oferta de trabajo',
      "videoEmbed": "ADMINISTRACIONDINERO7_03 (10).mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('p', [_vm._v("\n                Le ofrecen trabajo como ingeniera de soporte a las afueras de la ciudad, donde gana $1´200.000\n              ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner",
    attrs: {
      "xs5": ""
    }
  }, [_c('div', [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.aceptaTrabajo === 'acepta-trabajo'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-1', 'acepta-trabajo')
      }
    }
  }, [_vm._v("\n                  Lo acepta\n                ")]), _vm._v(" "), _c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.aceptaTrabajo === 'no-acepta-trabajo'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-1', 'no-acepta-trabajo')
      }
    }
  }, [_vm._v("\n                  No lo acepta\n                ")])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.preguntaDesc === 'acepta-trabajo-1') ? _c('seleccion-deci', {
    staticClass: "oferta-trabajo",
    style: (_vm.estilosDeci),
    attrs: {
      "selWidth": _vm.preguntaWidth
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-right": ""
    }
  }, [_c('ui-lsc-dialog', {
    attrs: {
      "vidTittle": 'Ahorrar en el fondo de empleados',
      "videoEmbed": "ADMINISTRACIONDINERO7_04 (11).mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "aligner",
    attrs: {
      "xs7": ""
    }
  }, [_c('p', [_vm._v("\n                Le ofrecen ahorrar en el fondo de empleados de la compañía\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.ahorrarFondo === 'acepta-ahorrar-fondo'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-2', 'acepta-ahorrar-fondo')
      }
    }
  }, [_vm._v("\n                  Lo acepta\n                ")]), _vm._v(" "), _c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.ahorrarFondo === 'no-acepta-ahorrar-fondo'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-2-no', 'no-acepta-ahorrar-fondo')
      }
    }
  }, [_vm._v("\n                  No lo acepta\n                ")])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.preguntaDesc === 'ahorrar-fondo') ? _c('seleccion-deci', {
    staticClass: "oferta-trabajo",
    style: (_vm.estilosDeci),
    attrs: {
      "selWidth": _vm.preguntaWidth
    }
  }, [_c('v-layout', {
    attrs: {
      "text-xs-center": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('ui-lsc-dialog', {
    attrs: {
      "vidTittle": 'Ahorrar en el fondo de empleados',
      "videoEmbed": "ADMINISTRACIONDINERO7_05 (12).mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.cantidadAhorroFondo === 'fondos-ahorra-5'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-3', 'fondos-ahorra-5')
      }
    }
  }, [_vm._v("\n                Ahorra 5% del salario. Aporta mensualmente $60.000\n              ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.cantidadAhorroFondo === 'fondos-ahorra-10'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-3', 'fondos-ahorra-10')
      }
    }
  }, [_vm._v("\n                Ahorra 10% del salario. Aporta mensualmente $120.000\n              ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.cantidadAhorroFondo === 'fondos-ahorra-15'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-3', 'fondos-ahorra-15')
      }
    }
  }, [_vm._v("\n                Ahorra 15% del salario. Aporta mensualmente $ 180.000\n              ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.preguntaDesc === 'acepta-trabajo-2') ? _c('seleccion-deci', {
    staticClass: "oferta-trabajo",
    style: (_vm.estilosDeci),
    attrs: {
      "selWidth": _vm.preguntaWidth
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('ui-lsc-dialog', {
    attrs: {
      "vidTittle": '¿Compra una moto?',
      "videoEmbed": "ADMINISTRACIONDINERO7_10 (17).mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner",
    attrs: {
      "xs7": ""
    }
  }, [_c('p', [_vm._v("\n                Está pensando en comprar moto para ir al trabajo\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('div', [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.comprarMoto === 'compra-nueva'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-4', 'compra-nueva')
      }
    }
  }, [_vm._v("\n                  Nueva $ 3.000.000\n                ")]), _vm._v(" "), _c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.comprarMoto === 'compra-usada'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-4', 'compra-usada')
      }
    }
  }, [_vm._v("\n                  Usada $ 2.200.000\n                ")]), _vm._v(" "), _c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.comprarMoto === 'no-compra'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-4', 'no-compra')
      }
    }
  }, [_vm._v("\n                  No compra\n                ")])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.preguntaDesc === 'comprar-moto-nueva') ? _c('seleccion-deci', {
    staticClass: "oferta-trabajo",
    style: (_vm.estilosDeci),
    attrs: {
      "selWidth": _vm.preguntaWidth
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('ui-lsc-dialog', {
    attrs: {
      "vidTittle": 'Compra moto nueva',
      "videoEmbed": "ADMINISTRACIONDINERO7_11 (18).mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Nueva $ 3.000.000")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.motoCredito === 'credito-nueva-1'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-5', 'credito-nueva-1')
      }
    }
  }, [_vm._v("\n                Crédito por el 80% a 36 meses con interés mensual del 1.2%."), _c('br'), _vm._v(" Cuota mensual de $85.000\n              ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.motoCredito === 'credito-nueva-2'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-5', 'credito-nueva-2')
      }
    }
  }, [_vm._v("\n                Crédito por el 80% a 24 meses con interés mensual del 1.3%."), _c('br'), _vm._v(" Cuota mensual de $118.000\n              ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.preguntaDesc === 'comprar-moto-usada') ? _c('seleccion-deci', {
    staticClass: "oferta-trabajo",
    style: (_vm.estilosDeci),
    attrs: {
      "selWidth": _vm.preguntaWidth
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('ui-lsc-dialog', {
    attrs: {
      "vidTittle": 'Compra moto usada',
      "videoEmbed": "ADMINISTRACIONDINERO7_14 (21).mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Usada $ 2.200.000")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.motoCredito === 'credito-usada-1'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-5', 'credito-usada-1')
      }
    }
  }, [_vm._v("\n                Crédito por el 60% a 24 meses con interés mensual del 1.5%."), _c('br'), _vm._v(" Cuota mensual de $67.000\n              ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.motoCredito === 'credito-usada-2'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-5', 'credito-usada-2')
      }
    }
  }, [_vm._v("\n                Crédito por el 60% a 12 meses con interés mensual del 1.5%."), _c('br'), _vm._v(" Cuota mensual de $123.000\n              ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.preguntaDesc === 'no-comprar-moto') ? _c('seleccion-deci', {
    staticClass: "oferta-trabajo",
    style: (_vm.estilosDeci),
    attrs: {
      "selWidth": _vm.preguntaWidth
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('ui-lsc-dialog', {
    attrs: {
      "vidTittle": 'No compra moto',
      "videoEmbed": "ADMINISTRACIONDINERO7_17 (24).mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("No compra")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.motoCredito === 'credito-no-moto-1'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-5', 'credito-no-moto-1')
      }
    }
  }, [_vm._v("\n                Toma bus de $1.500 que gasta 2 horas en llegar"), _c('br'), _vm._v(" Gasto mensual $66.000\n              ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.motoCredito === 'credito-no-moto-2'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-5', 'credito-no-moto-2')
      }
    }
  }, [_vm._v("\n                Toma colectivo de $2.000 que gasta hora y media en llegar."), _c('br'), _vm._v(" Gasto mensual $88.000\n              ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.preguntaDesc === 'no-acepta-trabajo-1') ? _c('seleccion-deci', {
    staticClass: "oferta-trabajo",
    style: (_vm.estilosDeci),
    attrs: {
      "selWidth": _vm.preguntaWidth
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('ui-lsc-dialog', {
    attrs: {
      "vidTittle": 'Explora otras opciones',
      "videoEmbed": "ADMINISTRACIONDINERO7_20 (27).mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner",
    attrs: {
      "xs5": ""
    }
  }, [_c('p', [_vm._v("\n                Se queda como independiente realizando mantenimiento de computadores.\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('div', [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.noAceptaTrabajo === 'no-acepta-trabajo-opc-1'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-6', 'no-acepta-trabajo-opc-1')
      }
    }
  }, [_vm._v("\n                  Cobra $30.000 por cada visita\n                ")]), _vm._v(" "), _c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.noAceptaTrabajo === 'no-acepta-trabajo-opc-2'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-6', 'no-acepta-trabajo-opc-2')
      }
    }
  }, [_vm._v("\n                  Hace paquetes de 5 visitas a sus clientes por $120.000 c/u.\n                ")]), _vm._v(" "), _c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.noAceptaTrabajo === 'no-acepta-trabajo-opc-3'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-6', 'no-acepta-trabajo-opc-3')
      }
    }
  }, [_vm._v("\n                  Espera una nueva oferta de trabajo que quede dentro de la ciudad\n                ")])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.preguntaDesc === 'botonDos') ? _c('seleccion-deci', {
    staticClass: "oferta-trabajo",
    style: (_vm.estilosDeci),
    attrs: {
      "selWidth": _vm.preguntaWidth
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('ui-lsc-dialog', {
    attrs: {
      "vidTittle": 'Irse de viaje',
      "videoEmbed": "ADMINISTRACIONDINERO7_24 (31).mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('p', [_vm._v("\n                Sus amigas están organizando un viaje para tomar unas vacaciones antes de empezar a trabajar. El viaje con todo incluido cuesta $1.000.000\n              ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner",
    attrs: {
      "xs5": ""
    }
  }, [_c('div', [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.ofertaViaje === 'va-de-viaje'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-7', 'va-de-viaje')
      }
    }
  }, [_vm._v("\n                  Va\n                ")]), _vm._v(" "), _c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.ofertaViaje === 'no-va-de-viaje'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-7-2', 'no-va-de-viaje')
      }
    }
  }, [_vm._v("\n                  No va\n                ")])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.preguntaDesc === 'viaje-tarjeta') ? _c('seleccion-deci', {
    staticClass: "oferta-trabajo",
    style: (_vm.estilosDeci),
    attrs: {
      "selWidth": _vm.preguntaWidth
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('ui-lsc-dialog', {
    attrs: {
      "vidTittle": 'Paga con tarjeta de crédito',
      "videoEmbed": "ADMINISTRACIONDINERO7_25 (32).mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Pago con tarjeta de crédito")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.viajeTarjeta === 'viaje-tarjeta-1'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-8', 'viaje-tarjeta-1')
      }
    }
  }, [_vm._v("\n                Difiere a 24 meses (2,2% de interés mensual)"), _c('br'), _vm._v(" Cuota mensual de $56.000\n              ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.viajeTarjeta === 'viaje-tarjeta-2'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-8', 'viaje-tarjeta-2')
      }
    }
  }, [_vm._v("\n                Difiere a 12 meses (2,2% de interés mensual)"), _c('br'), _vm._v(" Cuota mensual de $97.000\n              ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.preguntaDesc === 'viaje-libre-invesion') ? _c('seleccion-deci', {
    staticClass: "oferta-trabajo",
    style: (_vm.estilosDeci),
    attrs: {
      "selWidth": _vm.preguntaWidth
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('ui-lsc-dialog', {
    attrs: {
      "vidTittle": 'Usa un crédito de libre inversión',
      "videoEmbed": "ADMINISTRACIONDINERO7_28 (35).mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Toma un crédito de libre inversión por $1.000.000")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.viajeLibreInv === 'viaje-libre-invesion-1'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-9', 'viaje-libre-invesion-1')
      }
    }
  }, [_vm._v("\n                A 6 meses (1,5% de interés mensual)"), _c('br'), _vm._v(" Cuota mensual de $176.000\n              ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('bot-deci-opt', {
    attrs: {
      "botActiv": _vm.viajeLibreInv === 'viaje-libre-invesion-2'
    },
    nativeOn: {
      "click": function($event) {
        _vm.botsResp('pregunta-9', 'viaje-libre-invesion-2')
      }
    }
  }, [_vm._v("\n                A 1 año (1.5% de interés mensual) "), _c('br'), _vm._v(" Cuota mensual de $93.000\n              ")])], 1)], 1)], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.textosFinales) ? [_c('bot-opt-final', {
    staticClass: "boton-final",
    style: (_vm.estilosBotonFinal),
    nativeOn: {
      "click": function($event) {
        _vm.textosFinales = !_vm.textosFinales
      }
    }
  }), _vm._v(" "), (_vm.retroFinal === 'no-acepta-ahorrar-fondo') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_09 (16).mp4"
    }
  }, [_c('p', [_vm._v("\n            Al aceptar el trabajo Juliana va a empezar a recibir ingresos, pero si no hace un ahorro no logrará su meta de ahorrar para la cuota inicial de su casa\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'fondos-ahorra-5') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_06 (13).mp4",
      "finTitulos": ['Al cabo de un año ', 'Juliana habrá ahorrado ', '$720.000']
    }
  }, [_c('p', [_vm._v("\n            y va a lograr alcanzar su meta de ahorro para la cuota inicial de su casa. Entre más ahorre, más cerca estará de su meta.\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'fondos-ahorra-10') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_07 (14).mp4",
      "finTitulos": ['Al cabo de un año ', 'Juliana habrá ahorrado ', '$1.440.000']
    }
  }, [_c('p', [_vm._v("\n            y va a lograr alcanzar su meta de ahorro para la cuota inicial de su casa. Entre más ahorre, más cerca estará de su meta.\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'fondos-ahorra-15') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_08 (15).mp4",
      "finTitulos": ['Al cabo de un año ', 'Juliana habrá ahorrado ', '$2.160.000']
    }
  }, [_c('p', [_vm._v("\n            y va a lograr alcanzar su meta de ahorro para la cuota inicial de su casa. Entre más ahorre, más cerca estará de su meta.\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'credito-nueva-1') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_12 (19).mp4",
      "finTitulos": ['Al cabo de un año ', 'Juliana habrá pagado ', '$1.020.000']
    }
  }, [_c('p', [_vm._v("\n            por su nueva moto. Aunque inicialmente se considera un gasto en realidad es un ahorro pues Juliana se evita pagar transporte público y llega en menos tiempo a su trabajo.\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'credito-nueva-2') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_13 (20).mp4",
      "finTitulos": ['Al cabo de un año ', 'Juliana habrá pagado ', '$1.416.000']
    }
  }, [_c('p', [_vm._v("\n            por su nueva moto. Aunque inicialmente se considera un gasto en realidad es un ahorro pues Juliana se evita pagar transporte público y llega en menos tiempo a su trabajo.\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'credito-usada-1') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_15 (22).mp4",
      "finTitulos": ['Al cabo de un año ', 'Juliana habrá pagado ', '$804.000']
    }
  }, [_c('p', [_vm._v("\n            por su moto usada. Aunque inicialmente se considera un gasto en realidad es un ahorro pues Juliana se evita pagar transporte público y llega en menos tiempo a su trabajo.\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'credito-usada-2') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_16 (23).mp4",
      "finTitulos": ['Al cabo de un año ', 'Juliana habrá pagado ', '$1.476.000']
    }
  }, [_c('p', [_vm._v("\n            por su moto usada. Aunque inicialmente se considera un gasto en realidad es un ahorro pues Juliana se evita pagar transporte público y llega en menos tiempo a su trabajo.\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'credito-no-moto-1') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_18 (25).mp4",
      "finTitulos": ['Al cabo de un año ', 'Juliana habrá gastado ', '$792.000']
    }
  }, [_c('p', [_vm._v("\n            Si bien puede cubrir este gasto de transporte con su nuevo trabajo, este gasto no representa para Juliana ninguna posibilidad de ahorro.\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'credito-no-moto-2') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_19 (26).mp4",
      "finTitulos": ['Al cabo de un año ', 'Juliana habrá gastado ', '$1.056.000']
    }
  }, [_c('p', [_vm._v("\n            Si bien puede cubrir este gasto de transporte con su nuevo trabajo, este gasto no representa para Juliana ninguna posibilidad de ahorro.\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'no-acepta-trabajo-opc-1') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_21 (28).mp4",
      "finTitulosDos": "Los ingresos de"
    }
  }, [_c('p', [_c('strong', [_vm._v("Juliana son variables, dependiendo del número de clientes.")]), _vm._v(" Con 5 clientes por semana gana\n            "), _c('strong', [_vm._v("$600.000")]), _vm._v(" mientras con 10 gana\n            "), _c('strong', [_vm._v("$1.200.000.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" Si bien no es una cifra fija, Juliana genera ingresos y está mas cerca de su meta.\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'no-acepta-trabajo-opc-2') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_22 (29).mp4",
      "finTitulosDos": "Los ingresos de"
    }
  }, [_c('p', [_c('strong', [_vm._v("Juliana son variables, dependiendo del número de clientes.")]), _vm._v(" Esta opción le permite asegurar clientes y obtener referidos."), _c('br'), _c('br'), _vm._v(" Si consigue 10 visitas por semana puede lograr ingresos por $960.000 y estar más cerca de su meta.\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'no-acepta-trabajo-opc-3') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_23 (30).mp4",
      "finTitulosDos": "Esta opción "
    }
  }, [_c('p', [_c('strong', [_vm._v("no le va a permitir alcanzar la meta de ahorro de Juliana.")]), _vm._v(" Ella podría tomar el trabajo que le están ofreciendo mientras encuentra otra opción, de esta forma puede comenzar a aportar en la casa que es lo que ella desea\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'no-va-de-viaje') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_32 (38).mp4"
    }
  }, [_c('p', [_vm._v("\n            Si Juliana no va al viaje podría ahorrar más para la cuota inicial de su casa y de esta forma alcanzar más rápido su meta.\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'viaje-tarjeta-1') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_26 (33).mp4",
      "finTitulos": ['Al cabo de un año ', 'Juliana habrá pagado ', '$672.000']
    }
  }, [_c('p', [_vm._v("\n            lo que significa un gasto adicional que la alejará de su meta.\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'viaje-tarjeta-2') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_27 (34).mp4",
      "finTitulos": ['Al cabo de un año ', 'Juliana habrá pagado ', '$1.164.000']
    }
  }, [_c('p', [_vm._v("\n            lo que significa un gasto adicional que la alejará de su meta.\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'viaje-libre-invesion-1') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_30 (36).mp4",
      "finTitulos": [' Al cabo de seis meses ', 'Juliana habrá pagado ', '$1.056.000']
    }
  }, [_c('p', [_vm._v("\n            lo que significa un gasto adicional que la alejará de su meta.\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.retroFinal === 'viaje-libre-invesion-2') ? _c('bot-final-titu-uno', {
    staticClass: "textos-final",
    style: (_vm.estilosTextoFinal),
    attrs: {
      "video": "ADMINISTRACIONDINERO7_31 (37).mp4",
      "finTitulos": ['Al cabo de un año ', 'Juliana habrá pagado ', '$1.116.000']
    }
  }, [_c('p', [_vm._v("\n            lo que significa un gasto adicional que la alejará de su meta.\n          ")])]) : _vm._e()] : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Juliana")]), _vm._v(" acaba de graduarse como ingeniera de sistemas y su meta es ahorrar para la cuota inicial de una casa.\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04161b4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actividades/ActividadDecisiones.vue
// module id = 943
// module chunks = 1